import { render, staticRenderFns } from "./LoadingScreen80vh.vue?vue&type=template&id=6c4fa40b&"
import script from "./LoadingScreen80vh.vue?vue&type=script&lang=js&"
export * from "./LoadingScreen80vh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports